/*
 * Rennsieger — Emblem product page.
 *
 * Dropdown variant picker (emblems carry long fitment/size lists), live price +
 * availability, and the gallery. No dependencies; no-ops when its markup is absent.
 * Forked from the door-light product script, scoped to .rsg-em.
 */
(function () {
  'use strict';

  var root = document.querySelector('.rsg-em');
  if (!root) return;

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 2 });
  }

  /* ---------------- variant picker (dropdowns) ---------------- */
  function initVariants() {
    var form = root.querySelector('#rsg-em-form');
    var vEl = root.querySelector('[data-rsg-hp-variants]');
    var oEl = root.querySelector('[data-rsg-hp-options]');
    if (!form || !vEl || !oEl) return;

    var variants = JSON.parse(vEl.textContent);
    var optionNames = JSON.parse(oEl.textContent);

    var idInput = form.querySelector('[data-rsg-hp-id]');
    var priceEls = root.querySelectorAll('[data-rsg-hp-price]');
    var wasEl = root.querySelector('[data-rsg-hp-was]');
    var atc = root.querySelector('[data-rsg-hp-atc]');
    var atcLabel = root.querySelector('[data-rsg-hp-atc-label]');

    function selected() {
      return optionNames.map(function (_, i) {
        var s = form.querySelector('[data-opt-index="' + i + '"]');
        return s ? s.value : (variants[0] ? variants[0]['option' + (i + 1)] : '');
      });
    }

    function findVariant(vals) {
      for (var k = 0; k < variants.length; k++) {
        var m = true;
        for (var i = 0; i < vals.length; i++) {
          if (variants[k]['option' + (i + 1)] !== vals[i]) { m = false; break; }
        }
        if (m) return variants[k];
      }
      return null;
    }

    function render() {
      var cur = findVariant(selected());
      if (!cur) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = cur.id;
      priceEls.forEach(function (el) { el.textContent = money(cur.price); });
      if (atc) atc.disabled = !cur.available;
      if (atcLabel) atcLabel.textContent = cur.available ? 'Add to cart' : 'Sold out';
      if (wasEl) {
        if (cur.compare_at_price && cur.compare_at_price > cur.price) {
          wasEl.textContent = money(cur.compare_at_price);
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }
    }

    Array.prototype.slice.call(form.querySelectorAll('[data-rsg-em-opt]')).forEach(function (s) {
      s.addEventListener('change', render);
    });
    render();
  }

  /* ---------------- gallery ---------------- */
  function initGallery() {
    var main = root.querySelector('[data-rsg-gal-main]');
    var thumbs = root.querySelector('[data-rsg-gal-thumbs]');
    if (!main) return;
    var imgs = Array.prototype.slice.call(main.querySelectorAll('img'));
    function show(i) {
      imgs.forEach(function (m) { m.classList.toggle('is-on', +m.getAttribute('data-i') === i); });
      if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-on', +b.getAttribute('data-i') === i);
      });
    }
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { show(+b.getAttribute('data-i')); });
    });
  }

  function boot() {
    initVariants();
    initGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
